import { getUserProfileFromToken } from "./jwt";

const PRODUCT_ID_PROD_TINY = "prod_OaDIHVQwiyvU0k";
const PRODUCT_ID_DEV_TINY = "prod_OaDEo0F1lj38QD";

export const SOLO_CODE_PROD = "prod_HXjN9aML8fXChn";
export const SOLO_CODE_DEV = "prod_HXjPwsEONzD5oI";

export const PRO_CODE_PROD = "prod_J8jz9uooW4PLna";
export const PRO_CODE_DEV = "prod_J8kEW4NCKrP3nK";

export const PRO_MAX_CODE_PROD = "prod_StOP6NMUyjkTFY";
export const PRO_MAX_CODE_DEV = "prod_StOfjvclPrF0J6";

export const LOCAL_UI = "http://localhost:3000";
export const PREVIEW_UI = "https://preview.tiiny.co.uk";
export const WWW_UI = "https://www.tiiny.co.uk";
export const PROD_UI = "https://tiiny.host";

export const FREE_UPLOAD_LIMIT = 3;

export const getProductId = () => {
  const host = window.location.hostname;

  // Dev environments: localhost, preview, www
  const isDev =
    ["localhost", "127.0.0.1", "::1"].includes(host) ||
    host === "preview.tiiny.co.uk" ||
    host === "www.tiiny.co.uk";

  return isDev ? SOLO_CODE_DEV : SOLO_CODE_PROD;
};

export const isAIEnabled = () => {
  return true;
};

export const isFreeOrTinyUser = (userProfile) => {
  const profile = userProfile || getUserProfileFromToken();

  if (!profile) return true;

  if (!profile.productId) {
    return true;
  }

  return [PRODUCT_ID_DEV_TINY, PRODUCT_ID_PROD_TINY].includes(
    profile.productId,
  );
};

export const canSubmitUpload = (userProfile) => {
  // If no userProfile provided, try to get it from JWT token
  const profile = userProfile || getUserProfileFromToken();

  if (!profile) return false;

  if ([PRODUCT_ID_DEV_TINY, PRODUCT_ID_PROD_TINY].includes(profile.productId)) {
    return false;
  }

  if (profile.productId) {
    return true;
  }

  const { uploadResetDate, uploadCount } = profile;

  if (uploadCount === undefined || uploadResetDate === undefined) {
    return true;
  }

  const count = Number(uploadCount);
  const resetDate = uploadResetDate ? new Date(uploadResetDate) : null;
  if (
    !Number.isFinite(count) ||
    !resetDate ||
    Number.isNaN(resetDate.getTime())
  ) {
    return true;
  }
  const now = new Date();

  return now >= resetDate || uploadCount < FREE_UPLOAD_LIMIT;
};

export const handleUpgradeRedirect = () => {
  const host = window.location.hostname;

  let UI_URL;

  if (["localhost", "127.0.0.1", "::1"].includes(host)) {
    UI_URL = LOCAL_UI;
  } else if (host === "preview.tiiny.co.uk") {
    UI_URL = PREVIEW_UI;
  } else if (host === "www.tiiny.co.uk") {
    UI_URL = WWW_UI;
  } else {
    UI_URL = PROD_UI;
  }

  const productId = getProductId();
  const upgradeUrl = `${UI_URL}/manage/subscription/upgrade?planId=${productId}`;
  window.open(upgradeUrl, "_blank", "noopener,noreferrer");
};
